/*
 * Move all show or has or anything related to UAR to its own module.
 */

export const realtime = (state, getters) => {
    return getters['options/realtime'];
}

export const accessibility = (state) => {
    return state.accessibility;
}

export const accountSummaries = (state) => {
    return (state.balanceSummary && state.balanceSummary.accountSummaries) || [];
}

export const excludedAccounts = (state) => {
    return (state.balanceSummary && state.balanceSummary.excludedAccounts) || [];
}

export const balanceSummary = (state) => {
    return state.balanceSummary;
}

export const conids = (state) => {
    return state.conids;
}
export const competitors = (state) => {
    return state.competitors;
}

export const firstApprovedDate = (state) => {
    return (state.user||{}).firstApprovedDate;
}

export const fundamentals = (state) => {
    return state.fundamentals;
}

export const items = (state) => {
    return state.items;
}

export const features = (state) => {
    return state.features;
}

export const userFeatures = (state) => {
    return state.user.features || {};
}

export const userProps = (state) => {
    return (state.user && state.user.props) || {};
}

export const userAccts = (state) => {
    return (state.user && state.user.accts) || undefined;
}

export const isCNLang = (state) => {
    return $locale.language == 'zh';
}

export const isPaperUser = (state) => {
    return (state.sso?.loginType === 2);
}

export const markets = (state) => {
    return state.markets;
}

export const marketData = (state) => {
    return state.marketData;
}

export const secdefData = (state) => {
    return state.secdefData;
}

export const bond = (state) => {
    return state.secdefData && state.secdefData[0] && state.secdefData[0].bond;
}

export const marketsInfo = (state) => {
    return state.marketsInfo;
}

export const news = (state) => {
    return state.news;
}

export const newsContent = (state) => {
    return state.newsContent;
}

export const performance = (state) => {
    return state.performance;
}

export const period = (state, getters) => {
    if ($build.mode == 'production' && getters.isPaperUser) {
        return '1D';
    }
    return state.period;
}

export const pnl = (state) => {
    return state.pnl;
}

export const positions = (state) => {
    return state.positions;
}

export const priceHistory = (state) => {
    return state.priceHistory;
}

export const rates = (state) => {
    return state.rates;
}

export const user = (state) => {
    return state.user;
}

export const username = (state) => {
    return (state.user && state.user.username) || '';
}

export const isLiteUser = (state, getters) => {
    return getters['iserverData/isLiteUser'];
}

/* Returns the white branding id for the user
 * undefined for non white branded users */

export const wbId = (state) => {
    if (/clientam/.test(location.origin)) {
        return (state.user.wbId != null && state.user.wbId) || '-'; // return something so we hide all non-wb elements
    }
    if (state.user.wbId === null) {
        return '';
    }
    return state.user && state.user.wbId;
}

export const positionsSince = (state) => {
    return state.positionsSince;
}

export const iserver = (state) => {
    return state.iserver;
}

// deprecated
export const uar = (state) => {
    return state.uar;
}

export const isFAClient = (state) => {
    return (state.user && state.user.applicants) ?
            state.user.applicants.find(app => app.businessType == "FA_CLIENT") : false;
}

export const showMessageCenter = (state) => {
    return $build.mode == 'development' || state.user.uar.messageCenter;
}

export const showUserInfo = (state) => {
    return $build.mode == 'development' || state.user.uar.userInfo;
}

export const showWLMS = (state) => {
    return $build.mode == 'development' || state.user.features.wlms;
}

export const showIBAM = (state) => {
    return $build.mode == 'development' || state.user.props.isIBAMClient;
}

export const showBond = (state) => {
    return state.user && state.user.features && state.user.features.bond;
}

export const showCalendar = (state) => {
    return state.user && state.user.features && state.user.features.calendar;
}

export const showOptionChains = (state) => {
    return (state.user && state.user.features && state.user.features.optionChains) || isDev(state);
}

export const showMF = (state) => {
    return true;
    //return state.user && state.user.features && state.user.features.showMF;
}

export const showAdvisors = (state) => {
    return wbId(state) === '' || !isFAClient(state);
}

export const showPortfolioAnalyst = (state, getters) => {
    return isDev(state) || state.features.DISABLE_UAR || (state.user.uar.portfolioAnalyst && !getters.isPaperUser);
}

export const showSuggestionsForYou = (state) => {
    return (process.env.SHOW_SUGGESTIONS_FOR_YOU);
}

export const isProd = (state) => {
    return (window.env === 'v1');
}

export const showFyi = (state) => {
   return isDev(state) || state.user.uar.fyi;
}

export const showForum = (state) => {
    return wbId(state) === '';
}

export const isLocal = (state) => {
    return /local.*/.test(process.env.BUILD_ENV);
}

export const isAlphaUser = (state) => {
    return state.user && state.user.features && state.user.features.alpha;
}

export const hasDebugMenu = (state) => {
    return state.user && state.user.features && state.user.features.debugMenu;
}

export const isDev = (state) => {
    return $build.mode == 'development';
}

export const isCI  = (state) => {
    return (process.env.BUILD_ENV == 'build.ci') || (window.env == 'ci');
}

export const isQA = (state) => {
    return (process.env.BUILD_ENV == 'build.qa') || (window.env == 'qa');
}

export const amSessionId = (state) => {
    return state.amSessionId;
}

export const hasAmPicker = (state) => {
    return isProd(state) || process.env.AM_ACCOUNT_PICKER === true;
}

export const canTradeBonds = (state) => {
    return (state.user && state.user.features && state.user.features.bond) || false;
}

/**
 * Returns the path based on Standalone mode vs Client Portal mode
 */
export const appPath = (state) => {
    return process.env.APP !== undefined ? '/' : process.env.PUBLIC_PATH;
}

export const isAppMode = (state) => {
    return process.env.APP !== undefined;
}

export const brandInfo = (state) => {
    return state.brandInfo;
}

export const canShowLogo = (state, getters) => {
    return getters.wbId === '' && !/clientam/.test(location.origin);
}

export const brandLogo = (state, getters) => {
    if (!state.user.username) {
        return '';
    }

    if (state.brandInfo.am_banner) {
        return '/' + state.brandInfo.am_banner;
    } else if (getters.canShowLogo) {
        return '/images/2015/template/logo-ib-ibkr-txtwht.svg';
    }
    return '';
}

export const brandBlackLogo = (state, getters) => {
    if (!state.user.username) {
        return '';
    }
    if (state.brandInfo.am_banner) {
        return '/' + state.brandInfo.am_banner;
    } else if (getters.canShowLogo) {
        return '/images/2015/template/logo-ib-ibkr-txtblk.svg';
    }
    return '';
}

export const hasSso = (state) => {
    return !!process.env.HAS_SSO;
}

export const allAccounts = (state) => {
    return state.allAccounts || [];
}

export const selectedAccounts = (state) => {
    return (state.selectedAccounts.constructor === Array) ? state.selectedAccounts : [ state.selectedAccounts ];
}

export const selectedAcctIds = (state, getters) => {
    return getters.selectedAccounts.map(acct => acct.accountId) || [];
}

export const selectedAcctId = (state, getters) => {
    return getters.selectedAccounts && getters.selectedAccounts.length && getters.selectedAccounts[0].accountId;
}

export const selecteAcctAlias = (state, getters) => {
    let ret;
    let selectedAccount = getters?.selectedAccounts?.[0];
    if (selectedAccount) {
        if (selectedAccount.accountVan === 'Interactive Advisors') {
            ret = selectedAccount.accountVan;
        } else {
            ret = selectedAccount.accountAlias || selectedAccount.accountId;
        }
    }
    return ret;
}

export const showQuickTradeV2 = (state, getters) => {
    if (getters.isDev) {
        return true;
    }
    if (!getters.accountProperties || !getters.userProperties || !getters.selectedAcctId) {
        return true;
    } else if (Object.keys(getters.userProperties).length == 0) {
        return false; // user doesn't have tws support
    } else if (getters.userProperties.ReadOnlySession == 'yes') {
        return false; // read-only session
    } else if (!getters.accountProperties[getters.selectedAcctId]) {
        return true; // if account properties are not available, display button
    } else if (getters.accountProperties[getters.selectedAcctId].NoClientTrading == 'yes') {
        return false; // client has trading disabled
    } else {
        return true;
    }
}

export const showQuickTrade = (state, getters) => {
    const accounts = getters.iserverAccounts;
    if (accounts.length == 1 && accounts[0] == 'no') {
        console.debug('no trading accounts');
        return false;
    }
    return true;
}

/*
 * For accounts with UKL segment, we offer the client to pick between two account (Uxxx and UxxxF),
 * if selecting both, the NLV, the Unrealized PnL and the Excess Liq of only Uxxx should be displayed
 * and UxxxF data should not be taken into calculations
 * uniqueSelectedAccounts() filters out UxxxF from list of selected accounts if both Uxxx and UxxxF
 * exist in list of selected accounts
 */
export const uniqueSelectedAcctIds = (state, getters) => {
    const enabledAccounts = {};
    getters.selectedAcctIds.forEach(acct => {
        enabledAccounts[acct] = true;
    });
    getters.selectedAcctIds.forEach(acct => {
        if (enabledAccounts[acct + 'F']) {
            enabledAccounts[acct + 'F'] = false;
        }
    });
    return Object.keys(enabledAccounts).filter(key => enabledAccounts[key]);
}

export const ssoValidated = (state) => {
    return state.ssoValidated;
}

export const optionCombo = (state) => {
    return state.optionCombo;
}

export const totalSummary = (state) => {
    return state.balanceSummary && state.balanceSummary.total;
}

// deprecated use iserverData/connected maps
export const connectedIServer = (state, getters) => {
    //console.warn('use iserverData/connected');
    //console.trace();
    return getters['iserverData/connected'];
}

export const iserverAccounts = (state, getters) => {
    //console.warn('user iserverData/accounts');
    //console.trace();
    return getters['iserverData/accounts'];
}

export const applicants = (state) => {
    return (state.user && state.user.applicants) ? state.user.applicants : [];
}

/**
 * returns alpha3 code of the user's legal country
 */
export const legalCountry = (state, getters) => {
    if (getters.applicants.length === 0) return '';
    const legalCountry = getters.applicants[0].legalCountry;
    return (legalCountry && legalCountry.alpha3) || '';
}

export const fromMobile = (state) => {
    if (state.fromMobile) return true;
    return state.sso && /IBKR/.test(state.sso.CLIENT_APP);
}

export const fromTWS = (state) => {
    return state.sso && /(TWS|IBKR)/.test(state.sso.CLIENT_APP);
}

export const sso = (state) => {
    return state.sso || {};
}

export const showInBase = (state) => {
    return state.showInBase;
}

export const isAlphaEnv = (state) => {
    return window.env === 'alpha';
}

export const masterId = (state, getters, rootState) => {
    const acctMeta = rootState.portfolio.accountMeta;
    return acctMeta && acctMeta.master && acctMeta.master.id;
}

export const SFEnabled = (state) => {
    return state.user && state.user.has2fa || undefined;
}

export const isFreeTrial = (state) => {
    return state.sso && state.sso.IS_FREE_TRIAL;
}

export const clearingStatus = (state) => {
    const accts = userAccts(state);
    if (accts !== undefined) {
        const keys = Object.keys(accts);
        if (keys.length === 1) {
            return accts[keys[0]] && accts[keys[0]].clearingStatus;
        }
    }
    return false;
}

export const isAcctsEmpty = (state) => {
    const accts = userAccts(state);
    if (accts !== undefined) {
        const keys = Object.keys(accts);
        return keys.length === 0;
    }
    return false;
}

export const openDate = (state) => {
    const accts = userAccts(state);
    if (accts !== undefined) {
        const keys = Object.keys(accts);
        if (keys.length === 1) {
            return accts[keys[0]] && accts[keys[0]].openDate;
        }
    }
    return undefined;
}

export const isFunded = (state) => {
    const accts = userAccts(state);
    if (accts !== undefined) {
        const keys = Object.keys(accts);
        if (keys.length === 1) {
            return accts[keys[0]] && accts[keys[0]].isFunded;
        }
    }
    return false;
}

export const withinFirstWeek = (state) => {
    let date = undefined;
    if (isFreeTrial(state)) {
        if (openDate(state)) {
            date = $date.local(openDate(state));
        }
    } else {
        if (firstApprovedDate(state)) {
            date = $date.local(firstApprovedDate(state));
        }
    }
    if (date) {
        if ($date.local().diffDays(date) < 7) {
            return true;
        }
    }

    return false;
}

export const withinFirstMonth = (state) => {
    if (firstApprovedDate(state)) {
        const date = $date.local(firstApprovedDate(state));
        if ($date.local().diffDays(date) < 30) {
            return true;
        }
    }
    return false;
}

export const faviconUrl = (state) => {
    return state.faviconUrl;
}

export const notificationIconUrl = (state) => {
    return state.notificationIconUrl;
}

/*
 * This will hold incomplete md status for selected conid in Orderpriceinfo of order ticket, which will only be set by
 * isIncompleteMd from mixin, the main reason for this variable is to hold the state while orderpane is closed.
 */
export const isCurInComMd = (state) => {
    return state.isCurInComMd;
}

/*
 * This will indicate if selected conid in order ticket is incomplete or not, this getter can be used
 * outside Orderpriceinfo across CP, the value will be based on isCurInComMd. When isCurInComMd is
 * false, isInCompleteConidSel muse be false, when isCurInComMd is true, isInCompleteConidSel can be different,
 * for example, when orderpane is closed while selected conid in orderpriceinfo is incomplete, the value will be false.
 */
export const isInCompleteConidSel = (state) => {
    return state.isCurInComMd && state.isInCompleteConidSel;
}

export const pickerAccounts = (state) => {
    return (state.pickerAccounts || []);
}

export const showNewMf = (state, getters) => {
    return (getters.userFeatures && getters.userFeatures.newMf) || getters.isAlphaEnv;
}

export const routeLoading = (state) => {
    return state.routeLoading;
}

export const totalUnreadNotifications = (state, getters) => {
    let val = getters['am/pendingItemNum'];
    if (getters.showFyi) {
        val += getters['fyi/fyiUnreadNum'];
    }
    if (getters.showMessageCenter) {
        val = val + getters['am/amMessages'].length + getters['am/amCorporateActions'].length;
    }
    return val;
}

export const protectProd = (state) => {
    return isAlphaEnv(state) || isDev(state);
}

export const privacyMode = (state) => {
    return state.privacyMode;
}

export const userProperties = (state) => {
    return state.accountProperties?.userProperties;
}

export const accountProperties = (state) => {
    return state.accountProperties?.accountProperties;
}

export const europeResidencyIndex = (state, getters) => {
    const defaultIndex = {
        displayName: 'DAX',
        conid: 825711,
        exchange: 'ANYEXCH',
        id: 'dax'
    };
    const lCountry = legalCountry(state, getters);
    if (!lCountry) return defaultIndex;
    switch (lCountry) {
        case 'FRA':
            return {
                displayName: 'CAC40',
                conid: 946200,
                exchange: 'ANYEXCH',
                id: 'cac40'
            }
        case 'CHE':
            return {
                displayName: 'SMI',
                conid: 1328305,
                exchange: 'ANYEXCH',
                id: 'smi'
            }
        case 'ESP':
            return {
                displayName: 'IBEX',
                conid: 13796838,
                exchange: 'ANYEXCH',
                id: 'ibex'
            }
        case 'SWE':
            return {
                displayName: 'OMXS30',
                conid: 1328293,
                exchange: 'ANYEXCH',
                id: 'omxs30'
            }
        case 'RUS':
            return {
                displayName: 'RTX',
                conid: 10758536,
                exchange: 'ANYEXCH',
                id: 'rtx'
            }
        case 'ITA':
            return {
                displayName: 'IMIB',
                conid: 50916151,
                exchange: 'ANYEXCH',
                id: 'ftmib'
            }
        default:
            return defaultIndex;
    }
}

export const partialServiceInterruption = (state) => {
    return state.amStatus === 'database offline';
}

export const isAccountTaskPending = (state, getters) => {
    const showEDDWarnings = getters['abFeatures/showEDDWarn'];
    if (!showEDDWarnings || !getters.protectProd) {
        return false;
    }
    return state.isAccountTaskPending;
}

/**
 * Returns an array of objects containing deposit on credit hold for each currency for the
 * selected account
 * Object consists of 'currency', 'value' and 'date' till which its on hold
 */
export const depositOnCreditHold = (state, getters) => {
    const acctId = getters.selectedAcctId;
    if (!acctId) {
        return [];
    }
    const acctSummary = getters['portfolio/accountSummary'].find(s => s.acctId == acctId);
    if (!acctSummary) {
        return [];
    }
    const data = acctSummary.data.depositoncredithold;
    if (!data || !data.value) {
        return [];
    }
    return data.value.split(',').map(v => {
        const chunks = v.split(':');
        return {
            currency: chunks[0],
            date: chunks[1],
            amount: parseFloat(chunks[2])
        };
    });
}

/**
 * Returns numeric value which gives total amount of deposit on credit hold for the selected account
 * If account contains pending deposit in non-base currency, it is converted to base currency and
 * added to other pending deposits
 */
export const consolidatedDepositOnCreditHold = (state, getters) => {
    const acctId = getters.selectedAcctId;
    if (!acctId || (getters.depositOnCreditHold.length == 0)) {
        return undefined;
    }
    const acctLedger = getters['portfolio/accountLedger'].find(s => s.acctId == acctId);
    if (!acctLedger || !acctLedger.data) {
        return undefined;
    }
    const exchangeRates = {};
    for (let key in acctLedger.data) {
        exchangeRates[key] = acctLedger.data[key]['exchangerate'];
    };
    return getters.depositOnCreditHold.reduce((acc, h) => {
        acc += (h.amount * exchangeRates[h.currency]);
        return acc;
    }, 0);
}

export const supportsIBKeyWidget= (state, getters) => {
    const ibKeyEligible = getters.sso?.QUALIFIED_FOR_MOBILE_AUTH == "IBKEY";
    const forcedShow = state.forceShowIBKeyWidget;

    return ibKeyEligible || forcedShow;
}

export const forceShowIBKeyWidget= (state) => {
    return state.forceShowIBKeyWidget;
}

export const forceShowCryptoPopover = (state) => {
    return state.forceShowCryptoPopover;
}

export const isTestingCryptoPos = (state) => {
    return state.isTestingCryptoPos;
}

export const isFaOrIbroker = (state) => {
    return state.sso?.IS_MASTER;
}

export const ssoRestrictTrade = (state) => {
    return state.sso.SSO_RESTRICTION !== null && state.sso.SSO_RESTRICTION !== undefined;
}

//https://prod.ibkr-web.com/ibjira/browse/CPUI-198
export const hideCashReport = (state, getters) => {
    return getters.wbId === 'PSPL_SG1';
}

export const isReferrerAccountType = (state, getters) => {
    if (getters['portfolio/portfolioAccounts'].length) {
        return getters["portfolio/portfolioAccounts"][0].type === 'IB-REF'
    } else {
        return false
    }
}
